var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-wrap"},[_c('div',{staticClass:"reader-wrap"},[_c('span',{staticClass:"qr-loading"},[_vm._v(" "+_vm._s(_vm.loadingMessage))]),_vm._v(" "),_c('div',{attrs:{"id":"reader"}}),_vm._v(" "),(_vm.showClose)?_c('button',{staticClass:"close-button",on:{"click":_vm.closeScanner}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }